import { render, staticRenderFns } from "./SharedProductBasicInfo.template.vue?vue&type=template&id=9fe7ec60&scoped=true&"
var script = {}
import style0 from "./SharedProductBasicInfo.template.vue?vue&type=style&index=0&id=9fe7ec60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe7ec60",
  null
  
)

export default component.exports